import { makeStyles } from "@material-ui/core"

import ColorUtil from "@/utils/ColorUtil"
import { colors } from "@/styles/colors"

const useStyles = makeStyles(theme => ({
	header: {
		minHeight: theme.spacing(5),
		padding: theme.spacing(1, 2)
	},
	footer: {
		minHeight: theme.spacing(5),
		padding: theme.spacing(1, 2)
	},
	body: {
		padding: theme.spacing(3, 2)
	},
	shortBody: {
		padding: theme.spacing(3, 1.5, 1.5, 3)
	},
	headerChildren: {
		flex: 1
	},
	footerChildren: {
		flex: 1
	},
	deleteIcon: {
		width: theme.spacing(2),
		height: theme.spacing(2),
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[200]),
		transition: theme.transitions.create("all", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		}),
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[100])
		},
		"& svg": {
			width: theme.spacing(2),
			height: theme.spacing(2)
		}
	}
}))

export default useStyles
